import { useFieldArray, useForm } from "react-hook-form";
import { TWO_PERCENT } from "../../constants/variable";
import { InvoiceFactoringData } from "../../types/TransactionSummary";
import { AmountIcon, EyeIcon, FeesIcon, TrashIcon } from "../Icons";
import InputWithLabel from "../InputWithLabel";

export default function InvoiceFactoringService({
  invoiceFactoringData,
}: {
  invoiceFactoringData: InvoiceFactoringData;
}) {
  return (
    <section>
      <div className="flex justify-between items-start py-4">
        <div className="flex items-start">
          <div className="w-[200px]">
            <h3 className="text-lg font-semibold text-custom-dark-blue-new">
              Invoice Factoring
            </h3>
            <p className="text-sm text-gray-500">Taram</p>
          </div>

          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <p className="flex items-center gap-1 border rounded-md border-gray-300 bg-gray-50 px-3 py-1">
                <AmountIcon className="size-4" />{" "}
                <span className="text-gray-500">Amount:</span> $
                {invoiceFactoringData.invoice_amount}
              </p>

              <p className="flex items-center gap-1 border rounded-md border-gray-300 bg-gray-50 px-3 py-1">
                <FeesIcon className="size-4" />{" "}
                <span className="text-gray-500">Fee:</span> $
                {Number(invoiceFactoringData.invoice_amount) * TWO_PERCENT}
              </p>
            </div>
          </div>
        </div>

        <div className="w-[264px] flex items-center gap-3">
          <button className="flex items-center gap-1 text-custom-blue-new border border-custom-blue-new px-3 py-2 rounded-lg">
            <EyeIcon className="size-5" /> View Detail
          </button>
          <span
            className={`text-sm font-medium px-3 py-1 rounded-xl ${
              status === "Approved"
                ? "bg-green-50 text-green-500 border border-green-400"
                : "bg-gray-50 text-gray-500 border border-gray-400"
            }`}
          >
            ↑ {invoiceFactoringData.status || "Processing"}
          </span>
        </div>
      </div>

      <AdminIFForm />

      <div className="ml-[200px] space-x-3">
        <button className="bg-red-100 text-red-500 text-sm px-3 py-1 border border-red-500 rounded-xl">
          Deny
        </button>
        <button className="bg-green-100 text-green-500 text-sm px-3 py-1 border border-green-500 rounded-xl">
          Approve
        </button>
      </div>
    </section>
  );
}

type AdminIFFormType = {
  quotesData: {
    quote_name: string;
    quote_amount: string;
    eta: string;
  }[];
};

const initialState = { eta: "", quote_amount: "", quote_name: "" };

function AdminIFForm() {
  const { control, register } = useForm<AdminIFFormType>({
    defaultValues: { quotesData: [initialState] },
  });

  const { append, fields, remove } = useFieldArray({
    control,
    name: "quotesData",
  });

  return (
    <form>
      {fields.map((field, index) => (
        <div
          key={field.id}
          className="grid items-center grid-cols-[185px_200px_200px_150px_150px_100px] gap-4"
        >
          <InputWithLabel
            label=""
            type="text"
            placeholder="Enter Quote Name"
            {...register(`quotesData.${index}.quote_name`)}
          />
          <InputWithLabel
            label=""
            type="text"
            placeholder="Enter Quote Amount"
            {...register(`quotesData.${index}.quote_amount`)}
          />
          <InputWithLabel
            label=""
            type="text"
            placeholder="Enter ETA Days"
            {...register(`quotesData.${index}.eta`)}
          />
          <input type="file" placeholder="Upload Quotes" className="hidden" />
          <button
            type="button"
            className="-mt-2 flex items-center gap-1 text-custom-blue-new border border-custom-blue-new px-3 py-2 rounded-lg"
          >
            Upload Quotes
          </button>

          <button
            type="button"
            className="ml-2 -mt-2 flex items-center gap-1 text-custom-blue-new border border-custom-blue-new px-3 py-2 rounded-lg"
          >
            <EyeIcon className="size-5" /> View Detail
          </button>

          {index > 0 && (
            <button
              type="button"
              className="text-red-500 hover:underline"
              onClick={() => {
                remove(index);
              }}
            >
              <TrashIcon className="size-6" />
            </button>
          )}
        </div>
      ))}

      <div className="flex justify-between items-center">
        <button
          type="button"
          className="text-custom-blue-new border border-custom-blue-new px-2 py-[2px] rounded-lg"
          onClick={() => {
            append(initialState);
          }}
        >
          Add new Quote
        </button>
        <button
          type="submit"
          // disabled={isSubmitting}
          className="px-3 py-2 rounded-md bg-custom-blue-medium text-white font-medium"
        >
          {false ? "submitting.." : "Submit"}
        </button>
      </div>
    </form>
  );
}
